import { clsx } from 'clsx';
import { extendTailwindMerge, twMerge } from 'tailwind-merge';
export const cn = (...args) => twMerge(clsx(...args));
export const createCn = (options) => {
    const customTwMerge = extendTailwindMerge(options);
    return (...args) => customTwMerge(clsx(...args));
};
//# sourceMappingURL=ui.utils.js.map